import styled from 'styled-components';

import Button from '../../components/Button/Button';
import Heading from '../../components/Heading/Heading.styled';
import Container from '../../components/Layout/Container.styled';
import PaperStyled from '../../components/Paper/Paper.styled';

export const ConfirmationPageStyled = styled(Container)`
  padding-bottom: 30px;
`;

export const TopSectionStyled = styled.div``;

export const LogoWrapperStyled = styled.div`
  height: 75px;
  display: flex;
  justify-content: center;
`;

export const IdStyled = styled.div`
  padding: 10px 20px;
  margin-top: 40px;
  border-radius: 4px;
  background: #efefef;

  ${({ theme }) => `
    font-weight: ${theme.fontWeights.medium};
    font-size: ${theme.fontSizes.large};
  `}
`;

export const DetailsWrapperStyled = styled.div`
  display: flex;
  margin-top: 50px;
  gap: 50px;

  ${({ theme }) => `
    ${theme.devices.mobile} {
      flex-direction: column;
    }
  `}
`;

export const ColStyled = styled.div`
  width: 100%;

  & + & {
    border-left: 1px solid #cacaca;
    padding-left: 50px;

    ${({ theme }) => `
      ${theme.devices.mobile} {
        border-left: none;
        padding-left: 0;

        border-top: 1px solid #cacaca;
        padding-top: 50px;
      }
    `}
  }
`;

export const SectionTitleStyled = styled(Heading)`
  margin-bottom: 25px;
  text-transform: capitalize;

  ${({ theme }) => `
    font-size: ${theme.fontSizes.xLarge};
    color: ${theme.textColour};
  `}
`;

export const ListStyled = styled.ul`
  li + li {
    margin-top: 10px;
  }

  &:not(:last-of-type) {
    margin-bottom: 30px;
  }
`;

export const SubTitleStyled = styled(Heading)`
  margin-bottom: 12px;
  text-transform: capitalize;

  ${({ theme }) => `
    font-size: ${theme.fontSizes.medium};  
    color: ${theme.textColour};
  `}
`;

export const CardWrapperStyled = styled(PaperStyled)`
  padding: 20px;
  flex: 1 1 47%;
  margin: 0 !important;

  &:only-child {
    flex: 0 0 50%;

    ${({ theme }) => `
      ${theme.devices.touch} {
        flex: 1;
      }
    `}
  }
`;

export const CardImageWrapperStyled = styled.div`
  height: 160px;
  border-radius: 4px;

  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
    border-radius: inherit;
  }
`;

export const CardsWrapperStyled = styled.div`
  display: flex;
  gap: 30px;
  flex-wrap: wrap;

  &:not(:last-of-type) {
    margin-bottom: 30px;
  }
`;

export const CardNameStyled = styled.div`
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  min-height: 40px;
  margin-bottom: 5px;

  ${({ theme }) => `
    font-size: ${theme.fontSizes.normal}; 
    font-weight: ${theme.fontWeights.semibold}; 
  `}
`;

export const DetailsListStyled = styled.ul`
  li {
    margin-top: 10px;
  }

  li:last-child {
    margin-top: 20px;

    ${({ theme }) => `
      b {
        font-size: ${theme.fontSizes.medium};
      }
    `}
  }
`;

export const SummaryWrapperStyled = styled(PaperStyled)`
  margin-top: 40px;
`;

export const SummaryLabelStyled = styled(Heading)`
  ${({ theme }) => `
    color: ${theme.textColour};
  `}
`;

export const SummaryTopStyled = styled.div`
  display: flex;
  padding: 20px;

  border-bottom: 1px solid #cdcdcd;
`;

export const SummaryContentStyled = styled.div`
  padding: 20px;
`;

export const SummaryBottomStyled = styled.div`
  padding: 25px;
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #cdcdcd;
  text-transform: capitalize;

  ${({ theme }) => `
    font-size: ${theme.fontSizes.large};
    font-weight: ${theme.fontWeights.semibold};
  `}
`;

export const ColCommonDetailsStyled = styled.div`
  flex: 1;
  text-align: center;

  &:last-child {
    text-align: right;
  }
`;

export const ColSummaryStyled = styled(ColCommonDetailsStyled)`
  flex: 2;
  text-align: left;
`;

export const SummaryRowStyled = styled.div`
  display: flex;

  & + & {
    margin-top: 40px;
  }
`;

export const ContentStyled = styled.div`
  & + & {
    padding-top: 20px;
    margin-top: 20px;
    border-top: 1px solid #cdcdcd;
  }
`;

export const ContentTitleStyled = styled.div`
  border-bottom: 1px solid #cfcfcf;
  padding-bottom: 10px;
  margin-bottom: 10px;

  ${({ theme }) => `
    font-weight: ${theme.fontWeights.semibold};
  `}
`;

export const CertificateButtonStyled = styled(Button)`
  ${({ theme }) => `
    font-weight: ${theme.fontWeights.medium};
    color: ${theme.primaryColour};
    font-size: ${theme.fontSizes.medium};      
  `}
`;

export const CertificateButtonsWrapperStyled = styled.div`
  margin-top: 30px;
  display: flex;
  gap: 50px;
  flex-wrap: wrap;
`;

export const NoteStyled = styled.p`
  font-style: italic;
`;
